import translate from './i18n';
import TitleComponent from '../TitleComponent/index.vue';

export default {
  props: {
    orderId: {
      type: Number,
      required: true,
    },
  },
  components: {
    TitleComponent,
  },
  i18n: {
    ...translate,
  },
};
